import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import 'react-virtualized/styles.css';
import classNames from 'classnames';
import { H3, P, Flex, Box } from '@appcues/component-library';

import { IconButton } from '@studio/legacy-components';
import withTiming from 'components/Common/withTiming';

import { navigate } from 'actions/routing';
import { trackEvent } from 'actions/events';
import { updateUserUsageProperty } from 'actions/user';
import { showModal } from 'actions/currentModal';
import { selectAccountMeta } from 'reducers/account/meta';
import { selectAccountTags } from 'reducers/account/tags';
import { selectUserId } from 'reducers/user';
import {
  selectHasChromeExtensionInstalled,
  selectChromeExtensionId,
} from 'reducers/chromeExtension';
import { doubleCheckHasChromeExtension } from 'utils/chromeExtension';
import ProductLedCardItem from 'components/StepIndex/StepView/ProductLedCardItem';

import { CREATE_PRODUCT_LED_FLOW_MODAL } from 'constants/globals';
import { PRODUCT_LED_FLOWS } from 'constants/productLedFlows';
import { CLICKED_BUTTON, SAW_COMPONENT } from 'constants/events';

export class ProductLedExampleFlows extends Component {
  componentDidMount() {
    const { hasFlows, trackEvent: track } = this.props;
    track(SAW_COMPONENT, {
      componentName: 'ProductLedExampleFlows',
      hasFlows,
    });
  }

  createProductLedFlow = (userLifecycleStage, name) => {
    const {
      meta,
      chromeExtensionId,
      hasChromeExtensionInstalled,
      userId,
      trackEvent: track,
      showModal: show,
    } = this.props;
    const INSTALL_CRX_APPCUES_FLOW_ID = '-M3rSy4QkaoZ2YgGFHhc';

    doubleCheckHasChromeExtension(
      chromeExtensionId,
      hasChromeExtensionInstalled
    ).then(hasChromeExtension => {
      track(CLICKED_BUTTON, {
        buttonLabel: 'Opened Create Product Led Flow Modal',
        hasChromeExtensionBeenInstalled: hasChromeExtension,
        userLifecycleStage,
      });

      if (window.Appcues && !hasChromeExtension) {
        window.Appcues.show(INSTALL_CRX_APPCUES_FLOW_ID);
      } else {
        show(CREATE_PRODUCT_LED_FLOW_MODAL, {
          accountApiKey: meta.uuid,
          accountId: meta.id,
          userId,
          flowName: name,
          navigate,
          userLifecycleStage,
        });
      }
    });
  };

  toggleCollapse = () => {
    const {
      areProductLedFlowsMinimized,
      trackEvent: track,
      onUsage,
    } = this.props;
    track(CLICKED_BUTTON, {
      buttonLabel: 'Toggle Product Led Flows Component',
      areProductLedFlowsMinimized: !areProductLedFlowsMinimized,
    });
    onUsage(
      'hasProductLedFlowContainerBeenDismissed',
      !areProductLedFlowsMinimized
    );
  };

  render() {
    const { areProductLedFlowsMinimized } = this.props;

    return (
      <StyledFlowListContainer>
        <Flex
          alignItems="center"
          flexDirection="row"
          justifyContent="space-between"
        >
          <H3>Templates</H3>
          <IconButton
            aria-label="toggle examples"
            icon={areProductLedFlowsMinimized ? 'angle-down' : 'angle-up'}
            onClick={this.toggleCollapse}
          />
        </Flex>
        <Flex
          flexDirection="column"
          className={classNames(
            areProductLedFlowsMinimized ? 'minimized' : null
          )}
        >
          <P marginTop={8} marginBottom={4}>
            Starter content designed for common use cases.
          </P>
          <Grid
            minItemWidths={[190, [1300, 160], [1150, 250]]}
            marginTop="24px"
          >
            {PRODUCT_LED_FLOWS.map(productLedFlow => (
              <ProductLedCardItem
                key={productLedFlow.name}
                productLedFlow={productLedFlow}
                onClickProductLedFlowItem={this.createProductLedFlow}
              />
            ))}
          </Grid>
        </Flex>
      </StyledFlowListContainer>
    );
  }
}

const StyledFlowListContainer = styled.div`
  background: white;
  border-radius: 6px;
  box-shadow: 0px 2px 2px rgba(71, 88, 114, 0.08);
  padding: 24px;
  margin-bottom: 20px;
  min-width: 300px;

  .minimized {
    display: none;
    overflow: hidden;
  }
`;

const Grid = styled(Box)`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  row-gap: 24px;
  column-gap: 24px;
  width: 100%;
  & > * {
    width: 100%;
  }
  ${props =>
    props.minItemWidths &&
    props.minItemWidths.slice(1).map(
      ([breakpoint, minItemWidth]) =>
        `
      @media (max-width: ${breakpoint}px) {
        grid-template-columns: repeat(
          auto-fit,
          minmax(${minItemWidth}px, 1fr)
        );
      }
    `
    )}
`;

const mapDispatchToProps = {
  navigate,
  showModal,
  trackEvent,
  onUsage: updateUserUsageProperty,
};

function mapStateToProps(state) {
  return {
    userId: selectUserId(state),
    tags: selectAccountTags(state),
    meta: selectAccountMeta(state),
    hasChromeExtensionInstalled: selectHasChromeExtensionInstalled(state),
    chromeExtensionId: selectChromeExtensionId(state),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTiming(ProductLedExampleFlows, 'ProductLedExampleFlows'));
